import { createContext, Component } from 'react';

export const PreviewContext = createContext();

export const PreviewConsumer = PreviewContext.Consumer;
export const PreviewProvider = PreviewContext.Provider;

export const withPreviewContext = (WrappedComponent) => {

	class Preview extends Component {
		render(){
			return (
				<PreviewConsumer>
				{ (preview) => {
					return (
						<WrappedComponent {...this.props} preview={preview}/>
					)
				}}
				</PreviewConsumer>
			)
		}
	}

	return Preview;
}

